import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {v4 as uuidv4} from 'uuid';
import {BiAt} from 'react-icons/bi'
import {
    MdCollections,
    MdDns,
    MdOutlineCloudQueue,
    MdOutlineDomain,
    MdOutlineVerifiedUser
} from "react-icons/md";

import {
    AiOutlineAim,
    AiOutlineDashboard,
    AiOutlineSetting,
    AiOutlineTransaction
} from 'react-icons/ai'


const ICON_SIZE = '1.5em'

export const getMenuItems = () => {

    return [
        {
            id: uuidv4(),
            link: '/dashboard',
            label: 'Dashboard',
            icon: <AiOutlineDashboard size={ICON_SIZE}/>,
            rbac: 'GetDashboard',
        }, {
            id: uuidv4(),
            link: '/getting-started',
            label: 'Getting Started',
            icon: <AiOutlineAim size={ICON_SIZE}/>,
            rbac: 'ViewGettingStarted',
        }, {
            id: uuidv4(),
            link: '/domain-names',
            label: 'Domain Names',
            icon: <BiAt size={ICON_SIZE}/>,
            rbac: 'ListDomainNames',
        }, {
            id: uuidv4(),
            link: '/registrars',
            label: 'Registrars',
            icon: <MdDns size={ICON_SIZE}/>,
            rbac: 'ListRegistrars',
        }, {
            id: uuidv4(),
            link: '/hosted-zones',
            label: 'Hosted Zones',
            icon: <MdOutlineCloudQueue size={ICON_SIZE}/>,
            rbac: 'ListHostedZones',
        }, {
            // FNP-1186 — registered ahead of FNP-1191 and FNP-1193.
            // Records (FNP-1192) get no entry of their own: a record has no
            // identity outside its zone, so the module is reached from a
            // zone's detail view rather than from the navbar.
            id: uuidv4(),
            link: '/zones',
            label: 'Zones',
            icon: <MdOutlineDomain size={ICON_SIZE}/>,
            rbac: 'ListZones',
        }, {
            id: uuidv4(),
            link: '/certificates',
            label: 'Certificates',
            icon: <MdOutlineVerifiedUser size={ICON_SIZE}/>,
            rbac: 'ListCertificates',
        }, {
            id: uuidv4(),
            link: '/top-level-domains',
            label: 'Top Level Domains',
            icon: <MdCollections size={ICON_SIZE}/>,
            rbac: 'ListTopLevelDomains',
        }, {
            id: uuidv4(),
            link: '/application-products',
            label: 'Application Products',
            icon: <AiOutlineTransaction size={ICON_SIZE}/>,
            rbac: 'ListApplicationProducts',
        }, {
            id: uuidv4(),
            link: '/settings',
            label: 'Settings',
            icon: <AiOutlineSetting size={ICON_SIZE}/>,
            rbac: 'ListSettings'
        }] as PlatformNavbarMenuItem[];

};

